<template>
  <div>
    <!-- slider_area_start -->
    <div class="slider_area">
      <div class="single_slider d-flex align-items-center slider_bg_1">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-7 col-md-6">
              <div class="slider_text">
                <h3 class="wow fadeInDown" data-wow-duration="1s" data-wow-delay=".1s">
                  Find More Places
                  <br />with City Guider
                </h3>
                <p
                  class="wow fadeInLeft"
                  data-wow-duration="1s"
                  data-wow-delay=".1s"
                >Find Places Nears You, No Additional Sign Up required!</p>
                <div
                  class="video_service_btn wow fadeInLeft"
                  data-wow-duration="1s"
                  data-wow-delay=".1s"
                >
                  <a href="#" class="boxed-btn3">Download Now</a>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-md-6">
              <div class="phone_thumb wow fadeInDown" data-wow-duration="1.1s" data-wow-delay=".2s">
                <img src="@/assets/img/ilstrator/phone.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- slider_area_end -->

    <!-- service_area  -->
    <div class="service_area">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div
              class="section_title text-center wow fadeInUp"
              data-wow-duration=".5s"
              data-wow-delay=".3s"
            >
              <h3>
                Save your time and
                <br />us City Guider
              </h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4">
            <div
              class="single_service text-center wow fadeInUp"
              data-wow-duration=".6s"
              data-wow-delay=".4s"
            >
              <div class="thumb">
                <img src="@/assets/img/icon/partly_cloudy.png" alt />
              </div>
              <h3>
                Area wise <br/>
                Weather Forecast
              </h3>
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <div
              class="single_service text-center wow fadeInUp"
              data-wow-duration=".7s"
              data-wow-delay=".5s"
            >
              <div class="thumb">
                <img src="@/assets/img/icon/place.png" alt />
              </div>
              <h3>
                Nearby Places
                <br/>with Geo Location
              </h3>
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <div
              class="single_service text-center wow fadeInUp"
              data-wow-duration=".8s"
              data-wow-delay=".6s"
            >
              <div class="thumb">
                <img src="@/assets/img/icon/direction.png" alt />
              </div>
              <h3>
                Directions towards
                <br/> Your Favourite Location
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ service_area  -->

    <!-- service_area_2  -->
    <div class="service_area_2">
      <div class="container">
        <div class="row align-items-center">
          <div
            class="col-xl-4 col-lg-4 col-md-6 wow fadeInLeft"
            data-wow-duration=".4s"
            data-wow-delay=".5s"
          >
            <div class="man_thumb">
              <img src="@/assets/img/ilstrator_img/man_walk.png" alt />
            </div>
          </div>
          <div class="col-xl-5 offset-xl-1 col-lg-6 col-md-6">
            <div class="mobile_screen wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".5s">
              <img src="@/assets/img/ilstrator_img/mobile_screen.png" alt />
            </div>
          </div>
        </div>
        <div class="service_content_wrap">
          <div class="row">
            <div class="col-lg-4 col-md-4">
              <div class="single_service wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".3s">
                <span>01</span>
                <h3>Download App</h3>
                <p>Download app from Play Store and Install app in you android device. It's absolutely free.</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4">
              <div class="single_service wow fadeInUp" data-wow-duration=".6s" data-wow-delay=".4s">
                <span>02</span>
                <h3>Nearby Places</h3>
                <p>Nearby Places withing 8 - 12 km radius of your current location appears in Home Screen.</p>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-4 wow fadeInUp"
              data-wow-duration=".7s"
              data-wow-delay=".5s"
            >
              <div class="single_service">
                <span>03</span>
                <h3>Enjoy the app</h3>
                <p>Find your favourite places, Bookmark your favourite places, Direction to your favourite places.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ service_area_2  -->

    <!-- about  -->
    <div class="features_area">
      <div class="container">
        <div class="features_main_wrap">
          <div class="row align-items-center">
            <div class="col-xl-5 col-lg-5 col-md-6">
              <div class="features_info2">
                <h3>
                  Features that helps
                  you to find places
                </h3>
                <p>
                  All type of places Tourism, Restaurants, Hospitals, Bank & ATM's, Shops & Malls,
                  Police Stations, Cinema's, Parkings, Gym's & Salon's, Schools & Libraries and much more...
                </p>
                <div class="about_btn">
                  <a class="boxed-btn4" href="#">Download Now</a>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-lg-5 offset-xl-1 offset-lg-1 col-md-6">
              <div class="about_draw wow fadeInUp" data-wow-duration=".7s" data-wow-delay=".5s">
                <img src="@/assets/img/ilstrator_img/draw.png" alt />
              </div>
            </div>
          </div>
        </div>
          <div class="features_main_wrap">
          <div class="row align-items-center">
            <div class="col-xl-5 col-lg-5 offset-xl-1 offset-lg-1 col-md-6">
              <div class="about_image wow fadeInLeft" data-wow-duration=".4s" data-wow-delay=".3s">
                <img src="@/assets/img/ilstrator_img/phone.png" alt />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="features_info">
                <h3 class="wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".3s">
                  Easy Tourism
                  <br />Places Explorer
                </h3>
                <p
                  class="wow fadeInUp"
                  data-wow-duration=".6s"
                  data-wow-delay=".4s"
                >When you are in new city or region and you want to find tourism places.</p>
                <ul>
                  <li
                    class="wow fadeInUp"
                    data-wow-duration=".7s"
                    data-wow-delay=".5s"
                  >Find Places by Type.</li>
                  <li
                    class="wow fadeInUp"
                    data-wow-duration=".8s"
                    data-wow-delay=".6s"
                  >Place Keyword Search.</li>
                  <li
                    class="wow fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".7s"
                  >Search by Area.</li>
                </ul>

                <div class="about_btn wow fadeInUp" data-wow-duration=".10s" data-wow-delay=".8s">
                  <a class="boxed-btn4" href="#">Download Now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ about  -->
    <!-- testmonial_area  -->
    <div class="testmonial_area">
      <div class="container">
        <div class="col-xl-12">
          <div class="testmonial_active owl-carousel">
            <div
              class="single_testmonial text-center wow fadeInUp"
              data-wow-duration=".5s"
              data-wow-delay=".3s"
            >
              <div class="section_title">
                <h3>
                  Review from our
                  <br />regular users
                </h3>
              </div>
              <p>
                This app helps me to Find more tourism places
                <br />when I'm in new City.
              </p>
              <div class="rating_author">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <span>- Ismail Ahsan</span>
              </div>
            </div>
            <div
              class="single_testmonial text-center wow fadeInUp"
              data-wow-duration=".5s"
              data-wow-delay=".3s"
            >
              <div class="section_title">
                <h3>
                  Review from our
                  <br />regular users
                </h3>
              </div>
              <p>
                Alot of Features, Like Weather Forecast
                <br />Find Places of tourism.
              </p>
              <div class="rating_author">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <span>- Sana Irfan</span>
              </div>
            </div>
            <div
              class="single_testmonial text-center wow fadeInUp"
              data-wow-duration=".5s"
              data-wow-delay=".3s"
            >
              <div class="section_title">
                <h3>
                  Review from our
                  <br />regular users
                </h3>
              </div>
              <p>
                Geo Location Features is really awesome
                <br />to find nearby places.
              </p>
              <div class="rating_author">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <span>- Umer Shahzad</span>
              </div>
            </div>
            <div
              class="single_testmonial text-center wow fadeInUp"
              data-wow-duration=".5s"
              data-wow-delay=".3s"
            >
              <div class="section_title">
                <h3>
                  Review from our
                  <br />regular users
                </h3>
              </div>
              <p>
                Smooth UI, Easy to use no Signup Required
                <br />to use app features. It's Really
                <br />Awesome.
              </p>
              <div class="rating_author">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <span>- Usama Jahangeer</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ testmonial_area  -->
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>